import React from "react";

import {
    StyledMarkContainer,
    StyledRecommendation,
    StyledRecommendationContainer,
    StyledRecommendee
} from "../recommendation/recommendation.style";
import mark from "../../../img/mark.svg";
import {getRecommendee} from "./recommendationList";

const Recommendation = (props) => {

    const imgStyle = { "width": "60px" ,"height": "60px", "borderRadius": "9999px","filter": "grayscale(1)", "objectFit":"cover","padding":"5px" }
    const theme = props.theme || 'box';
    const recommendee = getRecommendee();

    return(
      <StyledRecommendationContainer theme={theme}>
          <StyledMarkContainer theme={theme}>
              <img src={mark} alt="" style={{transform: "translateY(-5px)"}}/>
              <img src={mark} alt="" style={{transform: "translateY(-5px)"}}/>
          </StyledMarkContainer>
          <StyledRecommendation>
              "{recommendee.recommendation}"
          </StyledRecommendation>

          <StyledRecommendee theme={theme}>
              <img src={recommendee.img} alt={"recommendee"} style={imgStyle}/>
              <div>
                  <h4> { recommendee.name }</h4>
                  <p> { recommendee.position }</p>
              </div>
          </StyledRecommendee>

      </StyledRecommendationContainer>
    );
}

export default React.memo(Recommendation);

